<template>
    <div :class="swiperWrapperClasses">
        <mq-layout :mq="['sm', 'md', 'pccFullSize']">
            <SwiperPaginationContainer
                :active-index="activePaginationIndex"
                @indexChange="onPaginationClick"
            />
        </mq-layout>
        <FlexContainer
            v-if="formLoadingStatus"
            :class="loadingWrapperClasses"
            :align-items="flexAlignItems.center"
            :justify-content="flexJustifyContent.center"
        >
            <Loader :size="loaderSizes.large" />
        </FlexContainer>
        <SpacingClassWrapper>
            <ScrollFlexContainer
                ref="scrollContainer"
                :max-width-px="780"
                :snap="scrollSnaps.x"
                :scroll-visibility="scrollbarApperance.hidden"
                @touchstart.native="touchMove = true"
                @wheel.native="onResultWheel"
                @scroll.native="onResultScroll"
            >
                <SpacingClassWrapper :margin-right="marginBetweenItems">
                    <TournamentPayoutsLayout />
                    <ChipDistributionLayout />
                </SpacingClassWrapper>
                <BlindStructureLayout />
            </ScrollFlexContainer>
        </SpacingClassWrapper>
    </div>
</template>

<script>
// Components
import Loader from '../../components/Loader';

// Class Wrappers
import SpacingClassWrapper from '../../classWrappers/SpacingClassWrapper';

// Containers
import SwiperPaginationContainer from '../../containers/results/SwiperPaginationContainer';
import ScrollFlexContainer from '../../containers/flex/ScrollFlexContainer';
import FlexContainer from '../../containers/flex/FlexContainer';

// Layouts
import TournamentPayoutsLayout from './TournamentPayoutsLayout';
import ChipDistributionLayout from './ChipDistributionLayout';
import BlindStructureLayout from './BlindStructureLayout';

// Types 
import { loaderSizes } from '../../types/Loader.types';
import { flexAlignItems, flexJustifyContent } from '../../types/Flex.types';
import { scrollSnaps, scrollbarApperance } from '../../types/ScrollFlex.types.js';

// Utils 
import { getActiveScrollChildrenIndex } from '../../utils/swiper-utils.js';
import { oneDirectionScrollToSmoothFallback } from '../../utils/scroll-utils';

// Mixins
import styles from '../../mixins/styles';

// Vuex 
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('pokerChipCalcModule');

export default {
    name: 'ResultsSwiperLayout',
    components: {
        // Components
        Loader,
        // Class Wrappers
        SpacingClassWrapper,
        // Containers
        SwiperPaginationContainer,
        ScrollFlexContainer,
        FlexContainer,
        // Layouts
        TournamentPayoutsLayout,
        ChipDistributionLayout,
        BlindStructureLayout,
    },
    mixins: [styles],
    data: function () {
        return {
            touchMove: true,
            activePaginationIndex: 0,
            marginBetweenItems: 4,
            // Types
            loaderSizes,
            flexAlignItems,
            flexJustifyContent,
            scrollSnaps,
            scrollbarApperance
        }
    },
    computed: {
        ...mapState([
            'formLoadingStatus',
            'smoothScrollAvailable'
        ]),
        spaceBetweenItems: function () {
            return this.marginBetweenItems * 5;
        },
        swiperWrapperClasses: function () {
            return [
                this.cssClasses.pcc__swiperWrapper
            ];
        },
        loadingWrapperClasses: function () {
            return [
                this.cssClasses.pcc__swiperWrapper_loadingWrapper
            ];
        }
    },
    methods: {
        getScrollChildrenWidth: function () {
            return this.$refs.scrollContainer.$slots.default.map(
                slotEl => slotEl.elm.clientWidth
            );
        },
        onPaginationClick: function (paginationIndex) {
            const scrollChildrenWidth = this.getScrollChildrenWidth().slice(0, paginationIndex);
            const childrenWidthSum = scrollChildrenWidth.reduce((scrollAcc, width) => scrollAcc + width, 0);
            const scrollLeft = childrenWidthSum + (this.spaceBetweenItems * paginationIndex);

            this.touchMove = false;
            this.scrollContainerToLeft(scrollLeft);
            this.changeActivePaginationIndex(paginationIndex);
        },
        changeActivePaginationIndex: function(newIndex) {
            this.activePaginationIndex = newIndex;
        },
        onResultWheel: function () {
            this.touchMove = true;
            this.onResultScroll();
        },
        onResultScroll: function() {
            if (!this.touchMove) return;
            const { $el: element } = this.$refs.scrollContainer
            const newPaginationIndex = getActiveScrollChildrenIndex(
                element,
                this.getScrollChildrenWidth(),
                this.spaceBetweenItems
            );
            if (newPaginationIndex !== this.activePaginationIndex) {
                this.changeActivePaginationIndex(newPaginationIndex);
            }
        },
        scrollContainerToLeft: function (distance) {
            const $scrollEl = this.$refs.scrollContainer.$el;
            if (this.smoothScrollAvailable) {
                $scrollEl.scrollTo({ left: distance , behavior: 'smooth' });
            } else {
                oneDirectionScrollToSmoothFallback($scrollEl, distance)
            }
        }
    }
}
</script>
